import React from 'react';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { useImportWizardStore } from '../../store/useImportWizardStore';
import { useSmartDefaults } from '../../hooks/useSmartDefaults';
import ImportModeSelector from './ImportModeSelector';
import CategorySelector from './CategorySelector';
import DealFieldMapping from './DealFieldMapping';
import AddressFieldMapping from './AddressFieldMapping';
import FlexAttributeMapping from './FlexAttributeMapping';
import StageStrategyConfig from './StageStrategyConfig';
import DispositionStrategyConfig from './DispositionStrategyConfig';
import OwnerStrategyConfig from './OwnerStrategyConfig';
import SaveConfigToggle from './SaveConfigToggle';

/**
 * Mapping configuration step - single column layout with max-width constraint.
 */
const MappingConfigStep: React.FC = () => {
  const importMode = useImportWizardStore((s) => s.mappingConfig.importMode);
  const setStep = useImportWizardStore((s) => s.setStep);

  useSmartDefaults();

  const handleNext = () => {
    setStep('validation');
  };

  return (
    <Box data-testid="mapping-config-step">
      <Typography variant="h6" sx={{ mb: 2 }}>
        Configure Column Mapping
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Paper sx={{ p: 2 }}>
          <ImportModeSelector />
        </Paper>

        <Paper sx={{ p: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Category
          </Typography>
          <CategorySelector />
        </Paper>

        <Paper sx={{ p: 2 }} data-testid="deal-field-mapping">
          <DealFieldMapping />
        </Paper>

        {importMode === 'deals_with_addresses' && (
          <Paper sx={{ p: 2 }} data-testid="address-field-mapping">
            <AddressFieldMapping />
          </Paper>
        )}

        <Paper sx={{ p: 2 }} data-testid="flex-attribute-mapping">
          <FlexAttributeMapping />
        </Paper>

        <Paper sx={{ p: 2 }}>
          <StageStrategyConfig />
        </Paper>

        <Paper sx={{ p: 2 }}>
          <DispositionStrategyConfig />
        </Paper>

        <Paper sx={{ p: 2 }}>
          <OwnerStrategyConfig />
        </Paper>

        <Divider />

        <SaveConfigToggle />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            aria-label="Proceed to validation"
          >
            Next
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MappingConfigStep;
